export default function tracking() {
  
  (function($){

    // function launchGA(){
    //   var el = document.createElement('script');
    //   el.setAttribute('type', 'text/javascript');
    //   el.setAttribute('async', true);
    //   el.setAttribute('src', '//www.googletagmanager.com/gtag/js?id=GTM-N6GQ45JH');
    //   document.body.append(el);
    //   window.dataLayer = window.dataLayer || [];
    //   function gtag(){dataLayer.push(arguments);}
    //   gtag('js', new Date());
    //   gtag('config', 'GTM-N6GQ45JH');
    //   }
      
    //   // La fonction qui relie Axeptio au lancement du cookie Google Analytics
    //   void 0 === window._axcb && (window._axcb = []);
    //   window._axcb.push(function(axeptio) {
    //        axeptio.on("cookies:complete", function(choices) {
    //       if(choices.google_analytics) {
    //          launchGA();
    //         }
    //        });
    //   });

  })(jQuery);
  
}
